import { __ } from "@wordpress/i18n";
import React, { useEffect, useState } from 'react';
import { Link, Route, Routes } from 'react-router-dom';
import apiFetch from '@wordpress/api-fetch';
import Footer from './layouts/Footer/Footer';
import Header from './layouts/Header/Header';
import Dashboard from "./pages/Dashboard/Dashboard";
import Settings from "./pages/Settings";
import { useMenu } from "./contexts/MenuContext";

import "bootstrap/dist/css/bootstrap.min.css";
import './style.scss';
const NotFound = () => (
    <div>
        <h2>{__( "404 - Page Not Found", "ultimate-security" )}</h2>
        <p>{__( "The page you are looking for does not exist.", "ultimate-security" )}</p>
        <Link to="/">{__( "Go back to Home", "ultimate-security" )}</Link>
    </div>
);

const useDetectChange = (obj1, obj2) => {
    return JSON.stringify(obj1) !== JSON.stringify(obj2);
};

const App = () => {
    const {
        settingData,
        setSettingData,
        reload,
        setChangeCount,
        menuData,
        communityItems
    } = useMenu();

    const [settingLoading, setSettingLoading] = useState(true);
    const [oldSettingData, setOldSettingData] = useState({});
    
    useEffect(() => {
        const fetchSettingData = async () => {
            try {
                const response = await apiFetch({ 
                    path: '/ultimate-security/v1/options', 
                    method: 'GET' 
                });
                // Update both the current and the old data to match
                setSettingData(response);
                setOldSettingData(response);
                setSettingLoading(false);
                // Clear all change tracking from localStorage on page reload
                clearAllChangeTracking();
                // Reset change count on fresh data load
                setChangeCount(false);
            } catch (error) {
                console.error("Error fetching settings data:", error);
            }
        };

        fetchSettingData();
    }, [reload]);

    // Function to clear all change tracking from localStorage
    const clearAllChangeTracking = () => {
        // Get all localStorage keys
        const keys = Object.keys(localStorage);
        // Filter for keys that start with 'changes_' (our tracking keys)
        const changeKeys = keys.filter(key => key.startsWith('changes_'));
        // Remove each change tracking key
        changeKeys.forEach(key => {
            localStorage.removeItem(key);
        });
    };

    useEffect(() => {
        // Only compare after initial load when oldSettingData is properly set
        if (Object.keys(oldSettingData).length > 0) {
            if (useDetectChange(settingData, oldSettingData)) {
                setChangeCount(true);
            } else {
                setChangeCount(false);
            }
        }
    }, [settingData, oldSettingData]);

    // Generate routes from menuData
    const generateRoutes = () => {
        const routes = [
            <Route key="dashboard" path="/" element={<Dashboard />} />
        ];
        
        // Helper function to recursively extract routes from menu data
        const extractRoutes = (items) => {
            items.forEach(item => {
                if (item.url && item.url !== "#" && item.url !== "/") {
                    routes.push(
                        <Route 
                            key={item.url} 
                            path={item.url} 
                            element={<Settings />} 
                        />
                    );
                }
                // Process sub-items if they exist
                if (item.sub && item.sub.length > 0) {
                    extractRoutes(item.sub);
                }
            });
        };
        
        // Extract routes from main menu and community items
        extractRoutes(menuData);
        extractRoutes(communityItems);
        // Add wildcard route
        routes.push(<Route key="not-found" path="*" element={<NotFound />} />);
        
        return routes;
    };

    return (
        <div className="usfw-settings-container">
            {
                settingLoading ? (
                    <div className="usfw-loading">
                        {__( "Loading...", "ultimate-security" )}
                    </div>
                ) : (
                    <>
                        <Header/>
                        <div className="container-fluid">
                            <Routes>
                                {generateRoutes()}
                            </Routes>
                        </div>
                        <Footer/>
                    </>       
                )
            }
        </div>
    );
};

export default App;
